/* ============================================================================
   pv-product-card — ADD TO BASKET toggle for snippets/pv-product-card.liquid.
   Adds the card's first available variant via /cart/add.js, flips the button
   to its IN BASKET ✓ success state (concept behavior) and refreshes every
   [data-cart-count] badge through window.Panelverse.refreshCartCount()
   (assets/panelverse.js cart-count contract).
   Delegated + guarded, so multiple sections can load this file safely.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__pvProductCardInit) return;
  window.__pvProductCardInit = true;

  document.addEventListener('click', function (ev) {
    var btn = ev.target && ev.target.closest ? ev.target.closest('[data-pv-add]') : null;
    if (!btn || btn.disabled || btn.classList.contains('is-added')) return;

    var id = Number(btn.getAttribute('data-variant-id'));
    if (!id) return;

    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart add failed');
        return res.json();
      })
      .then(function () {
        btn.disabled = false;
        btn.classList.add('is-added');
        if (window.Panelverse && window.Panelverse.refreshCartCount) {
          window.Panelverse.refreshCartCount();
        }
      })
      .catch(function () {
        btn.disabled = false;
      });
  });
})();
